import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLogger = (props) => /* @__PURE__ */ _jsxs("svg", {
	"xmlns:dc": "http://purl.org/dc/elements/1.1/",
	"xmlns:cc": "http://creativecommons.org/ns#",
	"xmlns:rdf": "http://www.w3.org/1999/02/22-rdf-syntax-ns#",
	"xmlns:svg": "http://www.w3.org/2000/svg",
	xmlns: "http://www.w3.org/2000/svg",
	"xmlns:sodipodi": "http://sodipodi.sourceforge.net/DTD/sodipodi-0.dtd",
	"xmlns:inkscape": "http://www.inkscape.org/namespaces/inkscape",
	"sodipodi:docname": "wood, log, nature.svg",
	"inkscape:version": "1.0 (4035a4fb49, 2020-05-01)",
	id: "svg405",
	viewBox: "0 0 16.933333 16.933334",
	height: 64,
	width: 64,
	...props,
	children: [
		/* @__PURE__ */ _jsxs("defs", {
			id: "defs399",
			children: [/* @__PURE__ */ _jsx("inkscape:path-effect", {
				hide_knots: "false",
				only_selected: "false",
				apply_with_radius: "true",
				apply_no_radius: "true",
				use_knot_distance: "true",
				flexible: "false",
				chamfer_steps: 1,
				radius: 0,
				mode: "F",
				method: "auto",
				unit: "px",
				satellites_param: "F,0,0,1,0,0,0,1 @ F,0,0,1,0,1.5875002,0,1 @ F,0,1,1,0,1.5875002,0,1 @ F,0,0,1,0,0,0,1 @ F,0,0,1,0,0,0,1",
				lpeversion: 1,
				is_visible: "true",
				id: "path-effect888",
				effect: "fillet_chamfer"
			}), /* @__PURE__ */ _jsx("inkscape:path-effect", {
				effect: "fillet_chamfer",
				id: "path-effect1198",
				is_visible: "true",
				lpeversion: 1,
				satellites_param: "F,0,0,1,0,0,0,1 @ F,0,0,1,0,1.5875002,0,1 @ F,0,1,1,0,1.5875002,0,1 @ F,0,0,1,0,0,0,1 @ F,0,0,1,0,0,0,1",
				unit: "px",
				method: "auto",
				mode: "F",
				radius: 0,
				chamfer_steps: 1,
				flexible: "false",
				use_knot_distance: "true",
				apply_no_radius: "true",
				apply_with_radius: "true",
				only_selected: "false",
				hide_knots: "false"
			})]
		}),
		/* @__PURE__ */ _jsx("sodipodi:namedview", {
			"inkscape:window-maximized": 1,
			"inkscape:window-y": -8,
			"inkscape:window-x": -8,
			"inkscape:window-height": 706,
			"inkscape:window-width": 1366,
			units: "px",
			showgrid: "false",
			"inkscape:document-rotation": 0,
			"inkscape:current-layer": "layer1",
			"inkscape:document-units": "px",
			"inkscape:cy": 18.301977,
			"inkscape:cx": 36.745019,
			"inkscape:zoom": 8.0556127,
			"inkscape:pageshadow": 2,
			"inkscape:pageopacity": 0,
			borderopacity: 1,
			bordercolor: "#666666",
			pagecolor: "#ffffff",
			id: "base"
		}),
		/* @__PURE__ */ _jsx("metadata", {
			id: "metadata402",
			children: /* @__PURE__ */ _jsx("rdf:rdf", { children: /* @__PURE__ */ _jsxs("cc:work", {
				"rdf:about": "",
				children: [
					/* @__PURE__ */ _jsx("dc:format", { children: "image/svg+xml" }),
					/* @__PURE__ */ _jsx("dc:type", { "rdf:resource": "http://purl.org/dc/dcmitype/StillImage" }),
					/* @__PURE__ */ _jsx("dc:title", {})
				]
			}) })
		}),
		/* @__PURE__ */ _jsx("g", {
			id: "layer1",
			"inkscape:groupmode": "layer",
			"inkscape:label": "Layer 1",
			children: /* @__PURE__ */ _jsxs("g", {
				transform: "matrix(0.99998445,0,0,0.99995895,30.42661,-310.74581)",
				style: {
					display: "inline",
					strokeWidth: 1.00003
				},
				id: "g1386",
				children: [/* @__PURE__ */ _jsx("path", {
					id: "path1369",
					d: "m -27.27306,317.10573 -2.332564,1.71739 -0.128164,2.46072 1.973709,2.10187 11.35523,-0.12816 2.2813,-1.48669 v -2.38383 l -1.230364,-1.74301 -2.511993,-0.43576 -1.255996,-0.0513 -0.128163,-1.99934 -1.050935,-0.0769 -1.127834,1.89681 z",
					style: {
						fill: "#d25400",
						fillOpacity: 1,
						fillRule: "evenodd",
						stroke: "none",
						strokeWidth: 1.05836,
						strokeLinejoin: "round",
						stopColor: "#000000"
					}
				}), /* @__PURE__ */ _jsxs("g", {
					style: { strokeWidth: 1.00003 },
					transform: "translate(-30.427083,31.75)",
					id: "g2818",
					children: [
						/* @__PURE__ */ _jsx("path", {
							d: "m 6.8791683,288.53333 a 3.1750016,3.1750016 0 0 1 -3.1750016,3.175 3.1750016,3.1750016 0 0 1 -3.17500167,-3.175 3.1750016,3.1750016 0 0 1 3.17500167,-3.17501 3.1750016,3.1750016 0 0 1 3.1750016,3.17501",
							style: {
								fill: "#e77e22",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "butt",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeOpacity: 1,
								stopColor: "#000000"
							},
							id: "circle1371"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path875",
							d: "m 3.7050781,284.83008 c -2.0394908,0 -3.7050834958154,1.66363 -3.7050781,3.70312 1.0277721e-6,2.03949 1.6655918,3.70508 3.7050781,3.70508 2.0394863,0 3.703124,-1.66559 3.703125,-3.70508 5.4e-6,-2.03949 -1.6636342,-3.70312 -3.703125,-3.70312 z m 0,1.05664 c 1.4675258,0 2.6445352,1.17896 2.6445313,2.64648 -8e-7,1.46753 -1.1770089,2.64649 -2.6445313,2.64649 -1.4675224,0 -2.6464836,-1.17896 -2.6464843,-2.64649 -3.9e-6,-1.46752 1.1789586,-2.64648 2.6464843,-2.64648 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "butt",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path879",
							d: "m 13.238281,284.83008 a 0.52916503,0.52916503 0 0 0 -0.53125,0.52734 0.52916503,0.52916503 0 0 0 0.527344,0.5293 c 1.46638,0.003 2.642397,1.18401 2.640625,2.65039 -0.0018,1.46638 -1.180102,2.64276 -2.646484,2.64258 a 0.52916503,0.52916503 0 0 0 -0.529297,0.52929 0.52916503,0.52916503 0 0 0 0.529297,0.5293 c 2.03794,2.5e-4 3.702618,-1.66323 3.705078,-3.70117 0.0025,-2.03794 -1.657376,-3.70236 -3.695313,-3.70703 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							d: "m 4.7625034,288.53333 a 1.0583367,1.0583367 0 0 1 -1.0583367,1.05833 1.0583367,1.0583367 0 0 1 -1.0583368,-1.05833 1.0583367,1.0583367 0 0 1 1.0583368,-1.05834 1.0583367,1.0583367 0 0 1 1.0583367,1.05834",
							style: {
								fill: "#d25400",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "butt",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeOpacity: 1,
								stopColor: "#000000"
							},
							id: "circle1373"
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path883",
							d: "m 3.7050781,286.94531 c -0.8704871,0 -1.5878933,0.71741 -1.5878906,1.58789 5.5e-6,0.87048 0.7174091,1.58789 1.5878906,1.58789 0.8704815,0 1.585932,-0.71741 1.5859375,-1.58789 2.7e-6,-0.87048 -0.7154504,-1.58789 -1.5859375,-1.58789 z m 0,1.0586 c 0.2985219,0 0.5273447,0.23077 0.5273438,0.52929 -1.9e-6,0.29852 -0.228824,0.5293 -0.5273438,0.5293 -0.2985198,0 -0.529295,-0.23078 -0.5292969,-0.5293 -9e-7,-0.29852 0.230775,-0.52929 0.5292969,-0.52929 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "butt",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path887",
							d: "m 10.054688,282.71289 a 0.52921795,0.52921795 0 0 0 -0.4746099,0.29297 l -0.9121093,1.82422 H 3.7050781 a 0.52916503,0.52916503 0 0 0 -0.5292969,0.52734 0.52916503,0.52916503 0 0 0 0.5292969,0.5293 H 8.9960938 A 0.52921795,0.52921795 0 0 0 9.46875,285.5957 l 0.912109,-1.82422 h 0.466797 v 1.58594 a 0.52921795,0.52921795 0 0 0 0.529297,0.5293 h 1.851563 a 0.52916503,0.52916503 0 0 0 0.529296,-0.5293 0.52916503,0.52916503 0 0 0 -0.529296,-0.52734 H 11.90625 v -1.58789 a 0.52921795,0.52921795 0 0 0 -0.529297,-0.5293 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path891",
							d: "m 3.7050781,291.17969 a 0.52916503,0.52916503 0 0 0 -0.5292969,0.52929 0.52916503,0.52916503 0 0 0 0.5292969,0.5293 h 9.5234379 a 0.52916503,0.52916503 0 0 0 0.529296,-0.5293 0.52916503,0.52916503 0 0 0 -0.529296,-0.52929 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path895",
							d: "m 10.054688,289.0625 a 0.52916503,0.52916503 0 0 0 -0.5292974,0.5293 0.52916503,0.52916503 0 0 0 0.5292974,0.52929 h 1.058593 a 0.52916503,0.52916503 0 0 0 0.529297,-0.52929 0.52916503,0.52916503 0 0 0 -0.529297,-0.5293 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						}),
						/* @__PURE__ */ _jsx("path", {
							id: "path899",
							d: "m 12.964844,286.94531 a 0.52916503,0.52916503 0 0 0 -0.529297,0.5293 0.52916503,0.52916503 0 0 0 0.529297,0.5293 h 1.058594 a 0.52916503,0.52916503 0 0 0 0.529296,-0.5293 0.52916503,0.52916503 0 0 0 -0.529296,-0.5293 z",
							style: {
								color: "#000000",
								fontStyle: "normal",
								fontVariant: "normal",
								fontWeight: "normal",
								fontStretch: "normal",
								fontSize: "medium",
								lineHeight: "normal",
								fontFamily: "sans-serif",
								fontVariantLigatures: "normal",
								fontVariantPosition: "normal",
								fontVariantCaps: "normal",
								fontVariantNumeric: "normal",
								fontVariantAlternates: "normal",
								fontVariantEastAsian: "normal",
								fontFeatureSettings: "normal",
								fontVariationSettings: "normal",
								textIndent: 0,
								textAlign: "start",
								textDecoration: "none",
								textDecorationLine: "none",
								textDecorationStyle: "solid",
								textDecorationColor: "#000000",
								letterSpacing: "normal",
								wordSpacing: "normal",
								textTransform: "none",
								writingMode: "lr-tb",
								direction: "ltr",
								textOrientation: "mixed",
								dominantBaseline: "auto",
								baselineShift: "baseline",
								textAnchor: "start",
								whiteSpace: "normal",
								shapePadding: 0,
								shapeMargin: 0,
								inlineSize: 0,
								clipRule: "nonzero",
								display: "inline",
								overflow: "visible",
								visibility: "visible",
								opacity: 1,
								isolation: "auto",
								mixBlendMode: "normal",
								colorInterpolation: "sRGB",
								colorInterpolationFilters: "linearRGB",
								solidColor: "#000000",
								solidOpacity: 1,
								vectorEffect: "none",
								fill: "#2d3e50",
								fillOpacity: 1,
								fillRule: "evenodd",
								stroke: "none",
								strokeWidth: 1.05836,
								strokeLinecap: "round",
								strokeLinejoin: "round",
								strokeMiterlimit: 4,
								strokeDasharray: "none",
								strokeDashoffset: 0,
								strokeOpacity: 1,
								colorRendering: "auto",
								imageRendering: "auto",
								shapeRendering: "auto",
								textRendering: "auto",
								enableBackground: "accumulate",
								stopColor: "#000000",
								stopOpacity: 1
							}
						})
					]
				})]
			})
		})
	]
});
export default SvgLogger;
